import type { Validator } from 'react-admin';

export const integer = (
  message = 'general.text.must_be_integer',
): Validator => (value) => {

  if (value === '' || value === null || value === undefined) return undefined;

  const numeric = typeof value === 'number' ? value : Number(value);

  if (!Number.isFinite(numeric) || !Number.isInteger(numeric)) {

    return message;

  }

  return undefined;

};
